export class Contact {
    type: string;
    name: string;
    phone: string;
    email: string;
    sendNfe: boolean;

    public populateFromServer(r: any) {

        if (r.type)
            this.type = r.type;

        if (r.name)
            this.name = r.name;

        if (r.phone)
            this.phone = r.phone;

        if (r.email)
            this.email = r.email;

        if (r.sendNfe)
            this.sendNfe = r.sendNfe;
    }
}



// WEBPACK FOOTER //
// ./src/app/models/billing-letter/Contact.model.ts